export const getPopularCitiesByState = (state: string) => {
  // CA provinces
  const CITY_LINKS_AB = [
    'calgary',
    'edmonton',
    'chipman-ab',
    'airdrie',
    'red-deer',
    'chestermere',
    'fort-mcmurray',
    'lethbridge'
  ]

  const CITY_LINKS_BC = [
    'vancouver',
    'burnaby',
    'surrey',
    'richmond',
    'north-vancouver',
    'coquitlam',
    'new-westminster',
    'west-vancouver',
    'langley',
    'port-moody',
    'kelowna',
    'white-rock',
    'victoria'
  ]

  const CITY_LINKS_ON = [
    'toronto',
    'north-york',
    'etobicoke',
    'scarborough',
    'mississauga',
    'vaughan',
    'richmond-hill',
    'brampton',
    'oshawa',
    'ajax',
    'markham',
    'east-york',
    'york',
    'hamilton',
    'kitchener',
    'london'
  ]

  const CITY_LINKS_QC = [
    'montreal',
    'laval',
    'quebec-city',
    'gatineau',
    'dorval',
    'brossard',
    'longueuil'
  ]

  const CITY_LINKS_NS = [
    'dartmouth',
    'bridgewater',
    'truro',
    'greenwood-ns',
    'kentville',
    'bedford',
    'lower-sackville',
    'windsor-ns',
    'wolfville',
    'new-glasgow',
    'antigonish'
  ]

  const CITY_LINKS_MB = [
    'winnipeg',
    'selkirk',
    'stonewall',
    'portage-la-prairie',
    'steinbach',
    'morden',
    'winkler',
    'altona',
    'brandon',
    'virden',
    'dauphin',
    'swan-river'
  ]

  // US states
  const CITY_LINKS_WA = [
    'seattle',
    'spokane',
    'tacoma',
    'vancouver-wa',
    'bellevue-wa',
    'kent-wa',
    'everett-wa',
    'renton',
    'spokane-valley',
    'federal-way',
    'bellingham-wa'
  ]

  const STATE_LINKS: Record<string, string[]> = {
    AB: CITY_LINKS_AB,
    BC: CITY_LINKS_BC,
    ON: CITY_LINKS_ON,
    QC: CITY_LINKS_QC,
    NS: CITY_LINKS_NS,
    MB: CITY_LINKS_MB,
    WA: CITY_LINKS_WA
  }

  const ALL_LINKS = [
    ...CITY_LINKS_BC,
    ...CITY_LINKS_ON,
    ...CITY_LINKS_AB,
    ...CITY_LINKS_QC,
    ...CITY_LINKS_NS,
    ...CITY_LINKS_MB
  ]

  const CITY_LINKS = STATE_LINKS[state] ?? ALL_LINKS

  return CITY_LINKS
}

export const toTitleCase = (str: string): string => {
  const excludedWords = [
    'a',
    'an',
    'and',
    'as',
    'at',
    'but',
    'by',
    'for',
    'in',
    'nor',
    'of',
    'on',
    'or',
    'so',
    'the',
    'to',
    'up',
    'yet',
    'AC',
    'AB',
    'BC',
    'MB',
    'NB',
    'NL',
    'NS',
    'NT',
    'NU',
    'ON',
    'PE',
    'QC',
    'SK',
    'YT'
  ]

  const excludedWordsLower = excludedWords.map(w => w.toLowerCase())

  return str
    .split(' ')
    .map((word, index, arr) => {
      const lowerWord = word.toLowerCase()
      if (
        excludedWordsLower.includes(lowerWord) &&
        index !== 0 &&
        index !== arr.length - 1
      ) {
        return word // leave original casing as-is
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    })
    .join(' ')
}
